/**
 * Admin Clients (Members) — the URL <-> filter-values seam, kept in a plain `.js`.
 *
 * The Filters modal is DRAFT-UNTIL-APPLY: `AdminFiltersModal` holds edits in local state and
 * only `Apply Filters` calls `onApply`, which routes through `writeFiltersToParams` into the
 * URL. The URL is the single source of truth — `readFiltersFromParams` reads it back, and only
 * then does `loadMembers` map `filters.active` onto the API's `isActive` param. Every link in
 * that chain must agree on the SAME key or a control silently applies nothing (card 8436).
 *
 * ⛔ `active` is the trap key: its values are the STRINGS `'true'` / `'false'`. `'false'` is
 *   truthy, so the `if (values[key])` guards pass it through correctly — but any refactor that
 *   coerces these to booleans would make `false` vanish at both guards and turn the Inactive
 *   filter into a no-op that still LOOKS wired, because the <select> keeps showing "Inactive".
 *
 * Extracted to a plain `.js` module rather than exported from the page because jest runs with
 * `transform: {}` and `moduleFileExtensions: ['js','mjs','json']`, so a `.jsx` cannot be
 * imported by a test at all — the same reasoning recorded in `web/pages/admin/orderStatusOptions.js`.
 */

// URL query params owned by the Filters experience — the URL is the source
// of truth, so refresh/back/forward and detail-page round-trips restore state
export const SELECT_FILTER_PARAMS = ['urgency', 'called', 'active', 'subStatus', 'tier', 'customTier', 'agency', 'test'];

export const readFiltersFromParams = (searchParams) => {
  const values = {};
  SELECT_FILTER_PARAMS.forEach((key) => {
    const value = searchParams.get(key);
    if (value) values[key] = value;
  });
  const preset = searchParams.get('preset');
  if (preset) {
    values.joined = {
      preset: preset.toUpperCase(),
      start: searchParams.get('from') || '',
      end: searchParams.get('to') || ''
    };
  }
  return values;
};

export const writeFiltersToParams = (values) => {
  const params = new URLSearchParams();
  SELECT_FILTER_PARAMS.forEach((key) => {
    if (values[key]) params.set(key, values[key]);
  });
  const joined = values.joined;
  if (joined?.preset) {
    // an incomplete custom range applies nothing — don't persist it
    const isComplete = joined.preset !== 'CUSTOM' || (joined.start && joined.end);
    if (isComplete) {
      params.set('preset', joined.preset);
      if (joined.preset === 'CUSTOM') {
        params.set('from', joined.start);
        params.set('to', joined.end);
      }
    }
  }
  return params;
};
